// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ml[data-v-0957c902] {\n  margin-left: 10px;\n}\n[data-v-0957c902] .el-drawer__body {\n  height: calc(100% - 77px);\n}\n", ""]);
// Exports
module.exports = exports;
